export default "/images/329e3d1fb939b7ce39cef6bcc129aa15.avif";